import slide1 from '../../assets/img/CompanyLogo/1.png';
import slide2 from '../../assets/img/CompanyLogo/2.png';
import slide3 from '../../assets/img/CompanyLogo/3.png';
import slide4 from '../../assets/img/CompanyLogo/4.png';
import slide5 from '../../assets/img/CompanyLogo/5.png';
import slide6 from '../../assets/img/CompanyLogo/6.png';
import slide7 from '../../assets/img/CompanyLogo/7.png';
import slide8 from '../../assets/img/CompanyLogo/8.png';
import slide9 from '../../assets/img/CompanyLogo/9.png';
import slide10 from '../../assets/img/CompanyLogo/10.png';
import slide11 from '../../assets/img/CompanyLogo/11.png';
import slide12 from '../../assets/img/CompanyLogo/12.png';
import slide13 from '../../assets/img/CompanyLogo/13.png';
import slide14 from '../../assets/img/CompanyLogo/14.png';
import slide15 from '../../assets/img/CompanyLogo/15.png';
import slide16 from '../../assets/img/CompanyLogo/16.png';
import slide17 from '../../assets/img/CompanyLogo/17.png';
import slide18 from '../../assets/img/CompanyLogo/18.png';
import slide19 from '../../assets/img/CompanyLogo/19.png';
import slide20 from '../../assets/img/CompanyLogo/20.png';
import slide21 from '../../assets/img/CompanyLogo/21.png';
import slide22 from '../../assets/img/CompanyLogo/22.png';
import slide23 from '../../assets/img/CompanyLogo/23.png';
import slide24 from '../../assets/img/CompanyLogo/24.png';

const logos = [
  { src: slide1, alt: 'Company 1' },
  { src: slide2, alt: 'Company 2' },
  { src: slide3, alt: 'Company 3' },
  { src: slide4, alt: 'Company 4' },
  { src: slide5, alt: 'Company 5' },
  { src: slide6, alt: 'Company 6' },
  { src: slide7, alt: 'Company 7' },
  { src: slide8, alt: 'Company 8' },
  { src: slide9, alt: 'Company 9' },
  { src: slide10, alt: 'Company 10' },
  { src: slide11, alt: 'Company 11' },
  { src: slide12, alt: 'Company 12' },
  { src: slide13, alt: 'Company 13' },
  { src: slide14, alt: 'Company 14' },
  { src: slide15, alt: 'Company 15' },
  { src: slide16, alt: 'Company 16' },
  { src: slide17, alt: 'Company 17' },
  { src: slide18, alt: 'Company 18' },
  { src: slide19, alt: 'Company 19' },
  { src: slide20, alt: 'Company 20' },
  { src: slide21, alt: 'Company 21' },
  { src: slide22, alt: 'Company 22' },
  { src: slide23, alt: 'Company 23' },
  { src: slide24, alt: 'Company 24' },
];


export default function CompanyLogos() {
  return (
  <div className="logoSection">
  <h2 className="title logos-title">Our Satisfied clients    </h2>
  <div className="row logoContainer">
    {logos.map((logo, index) => (
      <div key={index} className="col-12 col-md-4 col-lg-3 logoItem">
        <img src={logo.src} alt={logo.alt}   />
      </div>
    ))}
  </div>
</div>

  );
}
